import Head from 'next/head';
import Image from 'next/image';
import React from 'react';
import Meta from '../../components/Meta';
import Logo from "./../../public/images/LogoCirsys.svg"

const PrivacidadSection = ({ title, text, className }) => {
    return (
        <div className={`${className} pt-14`}>
            <h3 className={`mb-4 font-display text-lg text-white whitespace-pre-wrap`}>
                {title}
            </h3>
            <p className="text-jacarta-300 pb-4 whitespace-pre-wrap">{text}</p>
        </div>
    );
};

export default PrivacidadSection;
